import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelDirectorySmartEditModal from './ChannelDirectorySmartEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.channelDirectorySmartEditModal.status,
  id: state.modal.channelDirectorySmartEditModal.id,
  tags: state.tag.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getSmartDirectory: actions.storage.getSmartDirectory,
  updateSmartDirectory: actions.storage.updateSmartDirectory,
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DIRECTORY_SMART_EDIT, { status: false, id: null }),
  resetTable: () => actions.channel.updateTable({
    checkedList: [],
    indeterminate: false,
    checkAll: false
  })
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelDirectorySmartEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectorySmartEditModal/index.js